<script setup lang="ts">
import { useWallet } from 'solana-wallets-vue';
import { useSolBalance } from '@/helpers/solana/useSolBalance';
import SolanaIcon from './common/SolanaIcon.vue';
import { computed, ref } from 'vue';
import BaseAmountToken from '@/components/BaseAmountToken.vue';
import ValueButton from './common/ValueButton.vue';

const { solBalance } = useSolBalance();
const { connected } = useWallet();

const amount = defineModel<number>({
  default: 0,
  required: true,
});

defineProps({
  newPositionEarnings: {
    type: Number,
    required: true,
  },
});

const minSolInWallet = 0.01;

const maxAmount = computed(() => {
  return Math.floor(((solBalance.value ?? 0) - minSolInWallet) * 100) / 100;
});

const setMax = () => {
  if (solBalance.value && solBalance.value > minSolInWallet) {
    amount.value = maxAmount.value;
  }
};
const setHalf = () => {
  if (solBalance.value && solBalance.value > minSolInWallet) {
    amount.value = Math.floor((solBalance.value - minSolInWallet) * 50) / 100;
  }
};
</script>

<template>
  <div
    class="p-8 flex flex-col gap-2 border-b border-black/5 dark:border-white/5"
  >
    <div class="flex justify-between">
      <div class="text-opacity-60">
        <p v-if="!connected">No wallet detected</p>
        <p v-else-if="!solBalance">No SOL available</p>
        <p v-else>
          <button @click="setMax">{{ solBalance }} SOL</button>
        </p>
      </div>
      <div class="flex gap-2">
        <ValueButton label="HALF" @click="setHalf" />
        <ValueButton label="MAX" @click="setMax" />
      </div>
    </div>
    <div
      class="w-full flex bg-black/5 dark:bg-[#282B2E] rounded-lg overflow-hidden"
    >
      <input
        type="number"
        class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none flex-1 p-4 text-xl focus-within:outline-none"
        v-model="amount"
        :min="minSolInWallet"
        :max="connected ? maxAmount : undefined"
        :step="0.01"
      />
      <div class="self-center p-4 flex flex-row items-center gap-2">
        <span class="text-xl font-medium">SOL</span>
        <SolanaIcon class="w-8 h-8" />
      </div>
    </div>
    <p
      v-if="amount"
      class="text-sm text-medium-emphasis bg-primary/10 text-center rounded-lg p-2 text-primary"
    >
      <v-icon size="small" class="fill-primary inline mr-1 align-text-bottom"
        >mdi-hand-heart-outline</v-icon
      >
      By staking <strong>{{ amount }} SOL</strong> you're helping us while
      earning
      <strong
        ><BaseAmountToken
          :config="{
            amount: newPositionEarnings,
            isCollectible: false,
            label: 'SOL',
          }"
      /></strong>
      !
    </p>
  </div>
</template>
